"use strict";

angular.module("core").factory("ToggleNav", function($rootScope, $location, common) {
    var isCollapsed = true;
    return {
        isCollapsed: function() {
            return isCollapsed;
        },
        toggle: function() {
            // Fixes flashing toggle-nav's div when changing language
            if ($("#navbar-toggle").css("display") == "block") {
                isCollapsed = (isCollapsed = !isCollapsed);
                if (!isCollapsed) {
                    common.scrollTo("#top");
                }
                else {
                    $location.hash(null);
                }
                $rootScope.$broadcast("toggleNav");
            }
        }
    };

});



//////////////////
// WEBPACK FOOTER
// ./core/toggle-nav/toggle-nav.factory.js
// module id = 459
// module chunks = 0